<template>
  <div class="row" v-if="titleEnabled">
    <div class="col-lg-12 text-center">
      <h1>
        {{ T.siteTitle[lang] }}
        <button type="button" v-if="lang !== 'en'" title="Switch to English" @click="switchLanguage('en')">🇬🇧</button>
        <button type="button" v-if="lang !== 'hu'" title="Váltás magyar nyelvre" @click="switchLanguage('hu')">🇭🇺</button>
      </h1>
      <h1>
        <a
          v-for="y in YEARS"
          :key="y"
          class="badge mr-2"
          :class="getClass(y)"
          @click.prevent="yearChanged(y)"
          href="#"
        >{{ y === 2025 ? y + '.07' : y }}</a>
      </h1>
      <br>
    </div>
  </div>
</template>

<script>
import { YEARS, DREAMJOBS } from '../js/main';
import { T } from '../js/translations';
export default {
  props: {
    year: Number,
    lang: String
  },
  data: function() {
    return {
      titleEnabled: !DREAMJOBS,
      YEARS: YEARS,
      T: T
    };
  },
  computed: {
    getClass: function() {
      return function(year) {
        return {
          "badge-primary": this.year === year,
          "badge-secondary": this.year !== year
        };
      };
    }
  },
  methods: {
    yearChanged: function(year) {
      this.$emit("update:year", year);
    },
    switchLanguage: function(language) {
      this.$emit("update:lang", language);
    },
  }
};
</script>

<style scoped>
button {
  background: none;
  border: none;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// Title.vue?3fc8612e